import React, { useState, useRef, useEffect } from "react";
import { Headset, X, Send, Loader2 } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function SupportWidget() {
  const { supportOpen, setSupportOpen, sendSupport } = useApp();
  const [messages, setMessages] = useState([
    { id: "welcome", role: "assistant", text: "Hi! I'm Support \u2014 ask me anything about setting up or using your S71 portal." },
  ]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { endRef.current && endRef.current.scrollIntoView({ behavior: "smooth" }); }, [messages, supportOpen]);

  const newId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

  const send = async () => {
    const text = input.trim();
    if (!text || busy) return;
    setMessages((m) => [...m, { id: newId(), role: "user", text }]);
    setInput("");
    setBusy(true);
    const res = await sendSupport(text);
    setBusy(false);
    setMessages((m) => [...m, { id: newId(), role: "assistant", text: res.ok ? res.reply : (res.message || "Sorry, I couldn't respond.") }]);
  };

  return (
    <>
      {!supportOpen && (
        <button onClick={() => setSupportOpen(true)} className="fixed bottom-4 left-4 z-[75] flex items-center gap-2 h-11 px-4 rounded-full bg-[#8b5cf6] text-white text-[13px] font-semibold shadow-xl hover:bg-[#7c4ef0]">
          <Headset size={17} /> Support
        </button>
      )}
      {supportOpen && (
        <div className="fixed bottom-4 left-4 z-[85] w-[92vw] max-w-[360px] h-[70vh] max-h-[520px] rounded-2xl bg-[#101012] border border-white/10 shadow-2xl flex flex-col overflow-hidden">
          <div className="flex items-center justify-between px-4 h-12 border-b border-white/10 bg-[#8b5cf6]/10">
            <div className="flex items-center gap-2"><Headset size={16} className="text-[#a98bff]" /><span className="text-[13px] font-semibold">Support</span></div>
            <button onClick={() => setSupportOpen(false)} className="w-7 h-7 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10"><X size={15} /></button>
          </div>
          <div className="flex-1 overflow-y-auto px-3 py-3 space-y-2.5">
            {messages.map((msg) => (
              <div key={msg.id} className={`flex ${msg.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[82%] px-3 py-2 rounded-2xl text-[13px] leading-relaxed whitespace-pre-wrap ${msg.role === "user" ? "bg-[#8b5cf6] text-white rounded-br-sm" : "bg-white/[0.07] text-white/85 rounded-bl-sm"}`}>{msg.text}</div>
              </div>
            ))}
            {busy && <div className="flex justify-start"><div className="px-3 py-2 rounded-2xl bg-white/[0.07] text-white/60"><Loader2 size={15} className="animate-spin" /></div></div>}
            <div ref={endRef} />
          </div>
          <div className="p-2.5 border-t border-white/10 flex items-center gap-2">
            <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Ask Support..." className="flex-1 px-3 h-10 rounded-full bg-white/[0.06] border border-white/10 outline-none text-[14px] text-white placeholder:text-white/35" />
            <button onClick={send} disabled={busy} className="w-10 h-10 rounded-full bg-[#8b5cf6] text-white flex items-center justify-center hover:bg-[#7c4ef0] disabled:opacity-60"><Send size={16} /></button>
          </div>
        </div>
      )}
    </>
  );
}
